var c = function c() {
  function r(n) {
    var s = n + "=",
      t = document.cookie.split(";");
    for (var e = 0; e < t.length; e++) {
      var a = t[e];
      for (; a.charAt(0) == " ";) a = a.substring(1);
      if (a.indexOf(s) == 0) return a.substring(s.length, a.length);
    }
    return "";
  }
  function i(n) {
    var t = n.split(".")[1].replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(t));
  }
  window.dataLayer = window.dataLayer || [], function () {
    var t;
    var n = r("squanchy");
    var s = "VISITOR";
    if (n) {
      var e = i(n);
      s = ((t = e == null ? void 0 : e.user) == null ? void 0 : t.subscription_plan) || "VISITOR";
    }
    document.documentElement.setAttribute("data-mv-user-plan", s);
  }();
};
export { c as default };